/** fake functions to legacy rendered news */
window.lzld = function () {
    return false;
}

window.ads = {
    printAds: function (params) {
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/tracking/initFunctions.js